import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import {LoginService} from '../../login-service'
import {MessagesComponent} from './messages/messages.component';
import {ToastrModule} from 'ngx-toastr'
import { DatePipe } from '@angular/common'
import { element } from 'protractor';
import { FormControl, FormGroup } from '@angular/forms';
import {CollapseDirective} from 'ngx-bootstrap/collapse';
@Component({
    selector: 'initiatorcollabo-app',
    templateUrl: 'initiatorcollabo.component.html',
    providers:[LoginService,MessagesComponent,DatePipe]
})

export class InitiatorCollaboComponent implements OnInit {
  paytype:any
  paytype1:any;
  loc:any;
  actor:any;
  collabo:any;
  startdatesearch: any;
  enddatesearch:any
  showdetails1:boolean=false
  tabStatus:string;
  chatid:string;
  HiredUsers:any[];
  IsShowPraposal:boolean=false;
  TabDetails:string;
  ColaboActorDetails:any;
  SubCollaboButtonType:string
  tempColaboActorDetails:any;RowCollaboDetils: any;
  statusCollabos: any[];
  showPraposalDetails =[];
  collaboCheck: boolean;
  presentCollabos: any;
  statusList: any;
  kenvanView: any;
  expandedIndex = 0;
  c: any;
  Accordian: any;
  tempInvoiceList: any;
  InvoiceNo: string;
  InvoiceDate:any;
  legaldocumentsList: any;
  displayfiles: boolean=false;
 totalbids: any;
  filenameWithExtension: any;
  legaldocdetails: any;
  legaldocumentsList1: any;
  searchcolltext: any;
  showbids: any[];
  actorbids=[];
  SubCollaboist:any;
  CollaboID:string;
  userTypeNae:string;
  rowDetails:any;
  tabtype:string;
  PraposalActors=[];
    tempcollaboList:any;
    skilsList:any;
    openCollobo:boolean=true;
    inProgressCollobo:boolean=false;
    IsSubCollabo:boolean=false;
closedCollobo:boolean=false;
collaboList:any;
tempCol=[];
    Actorid: string;
    ActorpercentageId:string;
    IsMessage:boolean=false;
    IsCollaboDetails:boolean=false;
  userID: string;
  tempCollaboList:any;
CollaboPraposalDetails=[];
tempPraposaBids:any;
EachCollaoBids:string;
EachCollaboHired:string;
  maincollaboList: any;
  tempSubcollaboList: any=[];
  subcollaboList=[];
  statusWiseColCount={};
  subCollabos:boolean=false;
  type: any;
  count:number;
  showButton:boolean=false;
  IsCollabo:boolean=false;
  usersList:any;
  praposalBidsUsers:any;
  HiredColaboDetals:any;
  tempHiredCollaboDetails:any;
  ChatRoomsByUsers:any;
  searchText:string;
  tempcollabos=[];
  todaysdate=new Date();
  expired:boolean=false;
  tempbids=[];
  countArray=[];
  legaldocdetails1: any;
  details: any;
  showadvance:boolean=false;
  skills: string;
  showclearsearch: boolean=false;
  private isCollapsed: boolean = true;
  
    constructor(private loginService:LoginService, private toastr:ToastrModule,private router: Router,private msg:MessagesComponent,public datepipe: DatePipe) { 
      
      this.userID=localStorage.getItem('USERID');
      this.userTypeNae=localStorage.getItem('userType');
      this.GetPraposalBids();
      this.GetHiredCollabarators();
      this.GetCollabos();
     }

    ngOnInit() {
      this.getlegaldetails();
      this.GetChatRooms();
      this.InvoiceDate =this.datepipe.transform(this. todaysdate, 'yyyy-MM-dd');
      this.TabDetails='1';
      this.tabtype==='step1';
       this.type='display';
       this.count=0;
        this.GetSkills();
      this.GetUsers();
     this.c=this.statusCollabos[0];
     }
    
     accordianValue(value)
     {
       this.Accordian=value;
     }
     GetChatRooms(){
       this.loginService.GetChatRooms().subscribe(data=>{
        data = JSON.parse(data['_body']);
        this.ChatRoomsByUsers=JSON.parse(JSON.stringify(data));
      
       })
     }
     CancelCollabo(){
       this.IsCollaboDetails=false;
     }
GetUsers(){
this.loginService.GetUsers(this.userTypeNae).subscribe(data=>{
  data = JSON.parse(data['_body']);
  this.usersList=JSON.parse(JSON.stringify(data));

  


})
}
showdetails(row)
{
  this.showdetails1=true;
  this.getlegaldetails();
  this.details=row;
  this.legaldocdetails1=this.legaldocumentsList1.filter(x=>x.userid==row.userid)
}
Hidedetails()
{
  this.showdetails1=false;
}
Searchcolltext()
{
  this.tempbids=[];
  this.tempbids=this.showbids
if(this.searchcolltext!=undefined)
{
  const abc = this.showbids.filter((element) => element.bids.some((e => e.name.toLowerCase().indexOf(this.searchcolltext.toLowerCase().trim())>-1)))
  this.tempbids=abc;
  let tempCompany = this.showbids.filter(
    (item) => {
      return (
        (item.city !== null && item.city.toLowerCase().indexOf(this.searchcolltext.toLowerCase().trim()) > -1)||
        (item.country !== null && item.country.toLowerCase().indexOf(this.searchcolltext.toLowerCase().trim()) > -1)||
        (item.district !== null && item.district.toLowerCase().indexOf(this.searchcolltext.toLowerCase().trim()) > -1)||
         (item.username !== null && item.username.toLowerCase().indexOf(this.searchcolltext.toLowerCase().trim())>-1)
      );
    }
  );
if(this.searchcolltext==""){
  this.tempbids=this.tempbids;
}
else{
  if(abc.length>0)
  {
  this.tempbids=abc;
  }
  else{
  this.tempbids=tempCompany;
  }
  
}
 
 
}

}
opencollabo(item){
  this.c=item;
  this.totalbids=this.c.praposalBids;
  var filterArray = this.totalbids.reduce((accumalator, current) => {
    if(!accumalator.some(item => item.actorname === current.actorname )) {
      accumalator.push(current);
    }
    return accumalator;
  },[]);
var bids=[];
 this.countArray=[];
  var count=0;
  filterArray.forEach((element)=>{
    count=0;
    for(let i=0;i<this.totalbids.length;i++){
    if(element.actorname==this.totalbids[i].actorname) 
    {
   bids.push(element.actorname)
count=count+1;
    }
  }
    this.countArray.push({
  actor:element.actorname,
  count:count
});
  });
}

filteraccdates()
{
  console.log(this.startdatesearch,this.enddatesearch)
  console.log(this.statusCollabos)
  this.statusCollabos=this.statusCollabos.filter(x=>(x.createddate<=this.enddatesearch)&&(x.createddate>=this.startdatesearch))
  if(this.statusCollabos.length>0)
  {
    this.showclearsearch=true;
  }
  console.log(this.statusCollabos)
}
searchadvanced()
{
  if((this.loc==undefined)&&(this.actor==undefined)&&(this.skills==undefined)&&(this.collabo==undefined)&&(this.startdatesearch==undefined)&&(this.enddatesearch==undefined)&&this.paytype1==undefined)
          {
            return;
          }
  this.showclearsearch=true;
  console.log(this.statusCollabos,this.paytype1,this.collabo)
  if(this.loc==undefined){this.loc=""}
  if(this.actor==undefined){this.actor=""}
  if(this.skills==undefined){this.skills=""}
  if(this.collabo==undefined){this.collabo=""}
  if(this.startdatesearch==undefined){this.startdatesearch=""}
  if(this.enddatesearch==undefined){this.enddatesearch=""}
  if(this.paytype1==undefined){this.paytype=""}
  this.statusCollabos=[];
  this.statusCollabos=this.presentCollabos;
  this.tempcollabos = this.statusCollabos;
  if(this.paytype1=="1"){this.paytype="hour"}
  else if(this.paytype1=="2"){this.paytype="price"}
  else if(this.paytype1=="3"){this.paytype="percent"}
   let tempCompany = this.statusCollabos.filter(
     (item) => {
      console.log(item.pay_type,item.title)
      for(var i=0;i<item.ActorID.length;i++){
      //  item.createddate=this.datepipe.transform(item.createddate.toLowerCase().split("T")[0],'d MMM y')
       return (
         (item.title !== null && item.title.toLowerCase().indexOf(this.collabo.toLowerCase().trim()) > -1)&&(item.region !== null && item.region.toLowerCase().indexOf(this.loc.toLowerCase().trim()) > -1)&&(item.skillname !== null && item.skillname.toLowerCase().indexOf(this.skills.toLowerCase().trim()) > -1) &&(item.ActorID[i].name !== null && item.ActorID[i].name.toLowerCase().indexOf(this.actor.toLowerCase().trim()) > -1)&&(item.createddate.split("T")[0] !== null&&(item.pay_type !== null && item.pay_type.toLowerCase().indexOf(this.paytype.toLowerCase().trim()) > -1))
       );
      }
     }
  
   );
   this.statusCollabos = tempCompany;
}
cancel()
{
  this.showadvance=false;
  this.loc="";
  this.actor="";
  this.skills="";
  this.collabo="";
  this.startdatesearch="";
  this.enddatesearch="";
}

        cancelsearch()
        {
          this.showclearsearch=false;
          this.showadvance=false;
          this.statusCollabos=this.presentCollabos;
          this.loc="";
          this.actor="";
          this.skills="";
          this.collabo="";
          this.startdatesearch="";
          this.enddatesearch="";
        }
getlegaldetails()
{
  this.loginService.GetLegalDocuments().subscribe(data=>
    {  
      data = JSON.parse(data['_body']);
  this.legaldocumentsList1 =  JSON.parse(JSON.stringify(data));
})
}
     CollaboDetails(row,tab){
      this.IsCollaboDetails=true;
      
      this.rowDetails=row;
      console.log(this.rowDetails)
      if(this.rowDetails.CollaboDocumentPath==""&&this.rowDetails.LegalDocumentPath=="")
      {
        this.displayfiles=true;
      }
      else{
        this.displayfiles=false;
      }
      this.CollaboID=row.id;
      var todaysdate=this.datepipe.transform(this. todaysdate, 'yyyy-MM-dd');
      var enddate=this.datepipe.transform(this.rowDetails.end_date, 'dd-MM-yyyy');
      if(todaysdate>this.rowDetails.end_date.split("T")[0]){
        this.expired=true;
        
      }
      else{
        this.expired=false;
      }
var bids=this.rowDetails['praposalBids']
var users=[];
this.tempbids=[];
     for(var i=0;i<bids.length;i++){
       users.push(this.usersList.filter(x=>x.id==bids[i].userid))
     }
     var filterArray = users.reduce((accumalator, current) => {
      if(!accumalator.some(item => item[0].id === current[0].id )) {
        accumalator.push(current);
      }
      return accumalator;
  },[]);
  users=filterArray;
for(var i=0;i<users.length;i++){
  var bidsarray=this.tempPraposaBids.filter(x=>x.userid==users[i][0].id && x.collaboid==this.CollaboID)
  this.getlegaldetails();
  this.legaldocdetails=this.legaldocumentsList1.filter(x=>x.userid==users[i][0].id)
  this.tempbids.push({
userid:users[i][0].id,
username:users[i][0].user_name,
bids:bidsarray,
city:this.legaldocdetails[0].City,
country:this.legaldocdetails[0].Country,
district:this.legaldocdetails[0].DistrictTown
  })
  this.showbids=this.tempbids
   this.actorbids.push({userid:users[i][0].id,bids:bidsarray})
if(tab=='bids'){
  if(this.expired){
return;
  }
  this.tabChangeDetails(2);
}
else{
  this.tabChangeDetails(1);
}
}
  }
     GoToStep2(tabype){
              this.tabtype=tabype;
     }
     DeleteCollabo(data) {
    event.stopPropagation();
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this Collabo:' + data.title,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.delete(data.id);
      } else if (result.dismiss === Swal.DismissReason.cancel) {

      }
    })
  }

  delete(ID) {
    this.loginService.DeleteCollabos(ID,'d').subscribe(data => {
      this.GetCollabos();
      this.IsCollaboDetails=false;
     
      
    })
  }
  view(doc)
{
  window.open(this.loginService.imageURL+doc);
}
  BackToCollaboList(){
     this.IsCollaboDetails=false;
     this.TabDetails='1'
     this.showdetails1=false;
  }
  CreateCollabo(){
// this.IsCreate=true;

  }
  GetHiredCollabarators(){
    this.loginService.GetHiredCollabarators().subscribe(data=>
      {
          data = JSON.parse(data['_body']);
          this.tempHiredCollaboDetails=JSON.parse(JSON.stringify(data));



      });
  }
  GetPraposalBids(){
    this.loginService.GetPraposalBids().subscribe(data=>
      {
          data = JSON.parse(data['_body']);
          this.tempPraposaBids=JSON.parse(JSON.stringify(data));



      });
  }
  
    GetCollabos(){
     this.statusCollabos=[];
     this.tempCol=[];
        this.loginService.GetCollabos(this.userTypeNae).subscribe(data=>
            {
                data = JSON.parse(data['_body']);
                this.tempCollaboList=JSON.parse(JSON.stringify(data));
                if(this.tempCollaboList==undefined)
                {this.statusCollabos=[];
                return;}
if(this.tempCollaboList.length>0)
{


              this.loginService.GetCollaboActorDetails().subscribe(data1=>{
             data1=JSON.parse(data1["_body"]);
             this.tempColaboActorDetails=JSON.parse(JSON.stringify(data1));
                 this.loginService.GetPraposalBids().subscribe(data=>
                   {
                     data = JSON.parse(data['_body']);
                       this.tempPraposaBids=JSON.parse(JSON.stringify(data));


                       this.loginService.GetHiredCollabarators().subscribe(data=>
                        {
                            data = JSON.parse(data['_body']);
                            this.tempHiredCollaboDetails=JSON.parse(JSON.stringify(data));
               var collabolist=this.tempCollaboList.filter(x=>x.userid.toString()==this.userID.toString() && x.parentcollaboid==0);
                    this.collaboList=collabolist;
                    if(this.collaboList.length>0)
                    {
                    var temp=this.tempCollaboList.filter(x=>x.userid.toString()==this.userID.toString() && x.parentcollaboid!=0);
this.tempSubcollaboList=temp;
               if(this.collaboList.length>0)
      
for(let i=0;i<this.collaboList.length;i++)
{
let hiredDetails=this.tempHiredCollaboDetails.filter(x=>x.collaboid==this.collaboList[i].id)

if(hiredDetails.length>0){
this.HiredColaboDetals=hiredDetails;
this.EachCollaboHired=hiredDetails.length;

}
else{
this.HiredColaboDetals=[];
this.EachCollaboHired="0";
}
let CollaboActors=this.tempColaboActorDetails.filter(x=>x.CollaboId===this.collaboList[i].id);
if(CollaboActors.length>0)
{
  this.ColaboActorDetails=CollaboActors;
}
else{
  this.ColaboActorDetails=[];
}

  let tempSubCollabos=this.tempSubcollaboList.filter(x=>x.parentcollaboid===this.collaboList[i].id);
if(tempSubCollabos.length>0)
{
  this.IsSubCollabo=true;
}
else{
  this.IsSubCollabo=false;
}
let collabodetails:any
   collabodetails=this.tempPraposaBids.filter(x=>x.collaboid.toString()==this.collaboList[i].id.toString());
var hiredbids=this.tempPraposaBids.filter(x=>x.collaboid.toString()==this.collaboList[i].id.toString() && x.bidstatus=="Accepted");
   this.CollaboPraposalDetails=[];
for(let i=0;i<collabodetails.length;i++ )
{
   let filterHiredUsers=this.HiredColaboDetals.filter(x=>x.collaboid.toString()==collabodetails[i].collaboid && x.userid==collabodetails[i].userid)
  let IsHired:boolean=false;
if(filterHiredUsers.length>0){
IsHired=true;
}else{
  IsHired=false
}


  // if(filterHiredUsers.length>0){
    this.CollaboPraposalDetails.push({
      amount:collabodetails[i].amount,
      collaboid:collabodetails[i].collaboid,
      collabostatus:collabodetails[i].collabostatus,
      createdby:collabodetails[i].createdby,
createddate: collabodetails[i].createddate,
isactive: collabodetails[i].isactive,
description:collabodetails[i].description,
updatedby: collabodetails[i].updatedby,
updateddate: collabodetails[i].updateddate,
user_name:collabodetails[i].user_name,
IsHired:IsHired,
bidstatus:collabodetails[i].bidstatus,
actorids:collabodetails[i].actorids,
actorid:collabodetails[i].actorid,
actorname:collabodetails[i].name,
userid: collabodetails[i].userid,
totalhours: collabodetails[i].totalhours,
servicecharge:collabodetails[i].servicecharge,
rowid: collabodetails[i].rowid,
last_name: collabodetails[i].last_name,
first_name:collabodetails[i].first_name,
hoursestimated:collabodetails[i].hoursestimated,
    });
  }
// }
   if(collabodetails.length>0)
   {
     this.EachCollaoBids=collabodetails.length;
  }
   else{
     this.EachCollaoBids="0";
   }
  if(this.collaboList[i].ActorID==undefined || this.collaboList[i].ActorID=="" || this.collaboList[i].ActorID==[])
  {this.Actorid="";}
  else
{ this. Actorid= JSON.parse(this.collaboList[i].ActorID)
}

 if(this.collaboList[i].ActorPercentageID==undefined || this.collaboList[i].ActorPercentageID=="" || this.collaboList[i].ActorPercentageID==[])
 {this.ActorpercentageId="";
}
 else
{this. ActorpercentageId= JSON.parse(this.collaboList[i].ActorPercentageID)}

    this.tempCol.push({
        id:this.collaboList[i].id,
        category_id:this.collaboList[i].category_id,
        category: this.collaboList[i].category,
        sub_category_id: this.collaboList[i].sub_category_id,
        category1: this.collaboList[i].category1,
        name: this.collaboList[i].name,
        expected_budget: this.collaboList[i].expected_budget,
        estimated_time: this.collaboList[i].estimated_time,
        pay_type:this.collaboList[i].pay_type,
        status: this.collaboList[i].status,
        start_date:this.collaboList[i].start_date,
        end_date: this.collaboList[i].end_date,
        region: this.collaboList[i].region,
        SkillID: this.collaboList[i].SkillID,
        CollaboDocumentPath: this.collaboList[i].CollaboDocumentPath,
        CollaboDocumentname: this.collaboList[i].collabofilename,
        LegalDocumentname: this.collaboList[i].legaldocfilename,
        ProjectPeriod: this.collaboList[i].ProjectPeriod,
        SpecificTimeline: this.collaboList[i].SpecificTimeline,
        //ActorID:this.Actorid ,
        ActorID:this.ColaboActorDetails,
        actorname: this.collaboList[i].actorname,
        PayValue: this.collaboList[i].PayValue,
        LegalDocumentPath: this.collaboList[i].LegalDocumentPath,
        createdby: this.collaboList[i].createdby,
        description: this.collaboList[i].description,
        skillname:this.collaboList[i].skillname,
        createddate:this.collaboList[i].createddate.split("T")[0],
        ActorPercentageID:this.ActorpercentageId,
        title:this.collaboList[i].title,
        statusname:this.collaboList[i].statusname,
         Bids:this.EachCollaoBids,
        SubCollabo:this.IsSubCollabo,
        SubCollaboList:tempSubCollabos,
        praposalBids:this.CollaboPraposalDetails,
        HiredDetails:this.HiredColaboDetals,
        HiredUsers:this.HiredUsers,
        Hired:hiredbids.length
    }
    
    )
    this.GetStatus();
    this.statusChange(2);
  
}
}
else{
  this.statusCollabos=[];
}
                     })
                    
                    })
                    
                     });

                   
                    }
                   else 
                    {
                    
                      this.statusCollabos=[];
                      
                    }
                    });
    }

    statusChange(id){
      this.tabStatus=id;
      if(id==1){
        this.NewCollabo(0);
      }
      else if(id==2){
      this.statusCollabos=this.tempCol.filter(x=>x.status===1 || x.status===2);
      this.presentCollabos=this.statusCollabos;
      this.c=this.statusCollabos[0];
      }
      else{
        this.statusCollabos=this.tempCol.filter(x=>x.status===id);
      this.presentCollabos=this.statusCollabos;
      this.c=this.statusCollabos[0];
      }
    }

    GetStatus()
    {
      this.statusWiseColCount=[];
      this.loginService.GetStatus().subscribe(data=>
        {
          data=JSON.parse(data["_body"]);
          this.statusList=JSON.parse(JSON.stringify(data));
          for(let i=0;i<this.statusList.length;i++){
            let filterCols=this.tempCol.filter(x=>x.status==this.statusList[i].id)
            if(filterCols.length>0){
              this.statusWiseColCount={
                "id":this.statusList[i].id,
                "count":filterCols.length
              }
            }
          }
        })
    }
    ShowSubCollabos(id,SubCList,type){
      this.SubCollaboist=SubCList;
      this.SubCollaboButtonType=type;
    }

    tabChangeDetails(tabSelection){
this.TabDetails=tabSelection;
    }
    DisplaysubCollabos(id,list){
      this.ColaboActorDetails=[];
     this.subcollaboList=[];
         this.subCollabos=true;
          var sub=this.tempSubcollaboList.filter(x=>x.parentcollaboid===id);

          
for(let i=0;i<sub.length;i++)
{
  
let CollaboActors=this.tempColaboActorDetails.filter(x=>x.CollaboId===sub[i].id);
  if(CollaboActors.length>0)
  {
    this.ColaboActorDetails=CollaboActors;
  }
  else{
    this.ColaboActorDetails=[];
  }
  

          this.subcollaboList.push({
            id:sub[i].id,
            category_id:sub[i].category_id,
            category: sub[i].category,
            sub_category_id: sub[i].sub_category_id,
            category1: sub[i].category1,
            name: sub[i].name,
            expected_budget: sub[i].expected_budget,
            estimated_time: sub[i].estimated_time,
            pay_type:sub[i].pay_type,
            status: sub[i].status,
            start_date:sub[i].start_date,
            end_date: sub[i].end_date,
            region: sub[i].region,
            SkillID: sub[i].SkillID,
            CollaboDocumentPath: sub[i].CollaboDocumentPath,
            ProjectPeriod: sub[i].ProjectPeriod,
            SpecificTimeline: sub[i].SpecificTimeline,
            //ActorID:this.Actorid ,
            ActorID:this.ColaboActorDetails,
            actorname: sub[i].actorname,
            PayValue: sub[i].PayValue,
            LegalDocumentPath: sub[i].LegalDocumentPath,
            createdby: sub[i].createdby,
            description: sub[i].description,
            parentcollaboid:sub[i].parentcollaboid,
            skillname:sub[i].skillname,
            createddate:sub[i].createddate.split("T")[0],
            ActorPercentageID:this.ActorpercentageId,
            title:sub[i].title,
            statusname:sub[i].statusname,
            // Bids:this.collaboList[i].Bids,
            SubCollabo:this.IsSubCollabo,
           // SubCollaboList:tempSubCollabos
        }


          )
        
      }
       
       // }
      
      
    }
    hideSubcollabos(){
      this.subCollabos=false;
    }
    GetSkills(){
        this.loginService.Getskills(this.userTypeNae).subscribe(data=>{
           data = JSON.parse(data['_body']);
           this.skilsList=JSON.parse(JSON.stringify(data));
        })
    }
    openCol(){
        this.openCollobo=true;
        this.inProgressCollobo=false;
        this.closedCollobo=false;
    }
    inProgressCol(){
        this.openCollobo=false;
        this.inProgressCollobo=true;
        this.closedCollobo=false;
    }
    closedCol(){
        this.openCollobo=false;
        this.inProgressCollobo=false;
        this.closedCollobo=true;
    }
    NewSubCollabo(id)
    {
      this.CollaboID=id;
      this.router.navigate(['/initatorpostcollabo', this.CollaboID,'new']);
    }
    ShareDetails(row){
this.IsCollaboDetails=true;
this.rowDetails=row;
    }
    calculateDiff(sentDate,enddate) {
        var date1:any = new Date(sentDate);
        var date2:any = new Date(enddate);
        var diffDays:any = Math.floor((date2 - date1) / (1000 * 60 * 60 * 24));
    
        return diffDays;
    }
    EditColobo(row){
      //this.router.navigate(['/initatorhead/initatorcollabo']);
      this.router.navigate(['/initatorpostcollabo', row.id,'edit']);
    }
    NewCollabo(id){
      this.CollaboID=id;
      this.router.navigate(['/initatorpostcollabo', this.CollaboID,'new']);
    }

    BackToBids(tabtype,row){
      this.rowDetails=[];
      this.CollaboDetails(row,'details');
this.TabDetails=tabtype;
this.IsShowPraposal=false;
this.IsCollaboDetails=true;
this.tabtype='sh';

    }

    ShowPraposal(row,tabtype,userid,p)
    {
      this.PraposalActors=[];
      this.showPraposalDetails=[];
      this.IsShowPraposal=true;
    this.tabtype=tabtype;
    this.RowCollaboDetils=row;
    this.IsCollaboDetails=true;
let filterPraposals=this.tempPraposaBids.filter(x=>x.collaboid==row.id && x.userid.toString()==userid.toString() && x.rowid==p.rowid);

let CollaboActors=this.tempColaboActorDetails.filter(x=>x.CollaboId===row.id);

if(CollaboActors.length>0)
{
this.ColaboActorDetails=CollaboActors;
}
else{
this.ColaboActorDetails=[];
}
if(filterPraposals.length>0)
{
filterPraposals[0]['actorids'].split(',').forEach(element1 => {
let filterActor= this.ColaboActorDetails.filter(x=>x.ActorId.toString()===element1.toString()  )
if(filterActor.length>0)
this.PraposalActors.push({
RowID:filterActor[0].RowID,
ActorId:filterActor[0].ActorId,
name:filterActor[0].name,
CollaboId:filterActor[0].CollaboId,
NoOfActors:filterActor[0].NoOfActors,
Percentage:filterActor[0].Percentage,
Fees:filterActor[0].Fees
});

});
}



if(filterPraposals.length>0){
    


    this.showPraposalDetails.push({
        collabodetails:row,
        bidsDetails:filterPraposals[0],
TotalBidAmout:parseInt(filterPraposals[0].amount)-parseInt(filterPraposals[0].servicecharge),
praposalActors:this.PraposalActors
        })   

      


}

this.filenameWithExtension = this.showPraposalDetails[0]['bidsDetails'].proposalfilepath.replace(/^.*[\\\/]/, '');


}
changebidstatus(id,bidstatus,collaboid,userid,actorid,row){
  const json={
    rowid:"",
    colaboid:collaboid,
    userid:userid,
    actorid:actorid,
    bidid:id,
    status:bidstatus,
    createdbyparam:'admin',
    updatedbyparam:'admin'
  }
  var xyz=[];
  xyz=row.ActorID.filter(x=>x.ActorId==actorid);
  var b=(xyz[0].NoOfActors)-1;
  if(b<0)
  {
    b=0;
  }
  this.loginService.changenoofactors(b,xyz[0].RowID).subscribe(data=>{
    
  })
  this.loginService.changebidstatus(id,bidstatus).subscribe(data=>{
    // Swal.fire("Hired");
    this.loginService.showSuccess('Bid '+bidstatus, ""); 
    this.sendNotifications(json)
   if(bidstatus=="Accepted"){
     this.GenerateInvoice(json)
   }
    this.GetCollabos();
    this.GetPraposalBids();
    this.GetStatus();
    this.CollaboDetails(row,'details')
        })
}

GenerateInvoice(row){
  this.loginService.GetInvoices().subscribe(data=>{
    data = JSON.parse(data['_body']);
    this.tempInvoiceList=JSON.parse(JSON.stringify(data));
  var invoices=[];
  invoices=this.tempInvoiceList.filter(x=>x.collaboid==row.colaboid && x.userid==row.userID);
 var count=invoices.length;
 count=count+1
 this.InvoiceNo="INV" + row.colaboid +this.userID+ "0"+count;
var collaboartor=this.usersList.filter(x=>x.id==row.userid)
this.loginService.GetLegalDocuments().subscribe(data=>
  {  
    data = JSON.parse(data['_body']);
    this.legaldocumentsList =  JSON.parse(JSON.stringify(data));
var legaldoc=this.legaldocumentsList.filter(x=>x.userid==row.userid)
  const json={
    rowid:"",
    collaboid:row.colaboid,
    actorid:row.actorid,
    userid:row.userid,
    bidid:row.bidid,
    invoiceno:this.InvoiceNo,
    invoicedate:this.InvoiceDate,
    companyname:"",
    address:"",
    city:legaldoc[0].City,
    state:legaldoc[0].DistrictTown,
    country:legaldoc[0].Country,
    zipcode:"",
    phoneno:"",
    email:collaboartor[0].email,
    createdby:'admin',
    updatedby:'admin'
}
this.loginService.SaveInvoices(json).subscribe(data=>{
})
})
})
}
  SaveHiringCollabarators(collaboid,userid,row){

    const json={
      rowid:"",
      colaboid:collaboid,
      userid:userid,
      createdbyparam:'admin',
      updatedbyparam:'admin'
    }

    this.loginService.SaveHiringCollabarators(json).subscribe(data=>{
Swal.fire("Hired");
this.GetCollabos();
this.sendNotifications(json)
    })
  }
  sendNotifications(row){
let bidcollabo=this.tempCollaboList.filter(x=>x.id==row.colaboid)
    const json={
      id:0,
    name:'Hired',
    description:'Your bid for '+bidcollabo[0].title +' collabo has been ' +row.status,
    userid:this.userID,
    receiveruserid:row.userid,
    type:'Hired',
    typeid:0,
    createdby:'Admin',
    updatedby:'Admin',
    IsSender:0
    }
   
    this.loginService.SaveNotifications(json).subscribe(data=>{
    });
  }
  SendM(row){ 
    let filterChatRooms=this.ChatRoomsByUsers.filter(x=>x.userid.toString()==this.userID.toString() && x.receiveruserid.toString()==row.userid.toString() && x.collaboid==this.CollaboID);
    if(filterChatRooms.length>0){
    this.IsMessage=true;
    this.router.navigate(['/messages',row.userid,filterChatRooms[0].chatid,this.CollaboID]);
     
    }
   else{
    const json={
      chatid:this.chatid,
      userid:this.userID,
      createdbyparam:'admin',
      updatedbyparam:'admin',
      collaboid:row.collaboid,
      receiveruserid:row.userid
    }
    this.loginService.SaveChatRoomByUserID(json).subscribe(data=>{
      if(data["_body"].toString()!="0")
      {
      this.chatid=data["_body"];
      this.router.navigate(['/messages',row.userid,this.chatid,this.CollaboID]);
     
      this.GetChatRooms();
      }
    })
   // this.msg.newMessage('',row.user_name);
    this.IsMessage=true;
   }
  }
  getLegaldocuments(){
    this.loginService.GetLegalDocuments().subscribe(data=>
        {  
          data = JSON.parse(data['_body']);
          this.legaldocumentsList =  JSON.parse(JSON.stringify(data));
         
          // this.filtereddocList=this.documentsList.filter(x=>x.userid.toString()===this.userID.toString());
          
        });
   
 }
  Searchtext(){
    this.statusCollabos=[];
    this.statusCollabos=this.presentCollabos;
    this.tempcollabos = this.statusCollabos;
     let tempCompany = this.statusCollabos.filter(
       (item) => {
         return (
           (item.title !== null && item.title.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
         );
       }
    
     );
     this.statusCollabos = tempCompany;
     
  }
}
